import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LoginRequest } from '../models/loginRequest';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})

export class SignInComponent implements OnInit {
  signinForm: FormGroup;
  loading = false;
  submitted = false;
  error = '';

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    public alertService: ToastrService
  ) { }

  onForgotpassword() {
    this.router.navigate(['forgot-password'], { relativeTo: this.route.parent });
  }
  onSignup() {
    this.router.navigate(['sign-up'], { relativeTo: this.route.parent });
  }


  ngOnInit(): void {
    this.signinForm = this.fb.group({
      userName: ['', Validators.required],
      password: ['', Validators.required]
    });

  }

  get f() { return this.signinForm?.controls; }

  login() {
    const loginRequest: LoginRequest = {
      userName: this.f.userName.value,
      password: this.f.password.value
    };
    this.loading = true;
    this.authService.login(loginRequest)
      .subscribe({
        next: (user) => {
          if (user.responseCode) {
            this.alertService.success(user.responseDescription);
            this.router.navigate([this.authService.getInitialPathForRole(user.role)])

          } else {
            this.error = user.responseDescription;
            this.loading = false;
          }
        },
        error: errorr => {
          this.error = errorr.error.responseDescription ?? "An Error Occured, Please Contact Administrator";
          this.loading = false;
        }

      }

      );
  }


}
